export const AUTH_TOKEN_COOKIE = "tms_token";
export const LOGIN_PATH = "/login";
export const START_PATH = "/chat";
export const SESSION_EXPIRED_PATH = "/login?reason=session_expired";
export const SIGNED_OUT_PATH = "/login?reason=signed_out";
